import { BaseEdge, MarkerType, type Position, getSmoothStepPath } from '@xyflow/react';
import { type FlowContact } from '../types';
import { ContactFlowVisualizer } from '../components/ContactFlowVisualizer';
import { brandPrimary } from '../../../styles/colors';

/**
 * Color Mapping (from hardcoded → theme):
 * #3b82f6 → brandPrimary (selected edge)
 * #94a3b8 → EDGE_DEFAULT_COLOR (unselected edge - keeping as constant, slate gray)
 */

const EDGE_DEFAULT_COLOR = '#94a3b8';

interface DefaultEdgeProps {
	id: string;
	sourceX: number;
	sourceY: number;
	targetX: number;
	targetY: number;
	sourcePosition: Position;
	targetPosition: Position;
	selected?: boolean;
	data?: {
		activeContacts?: FlowContact[];
	};
	source: string;
	target: string;
}

export function DefaultEdge(props: DefaultEdgeProps) {
	const {
		id,
		sourceX,
		sourceY,
		targetX,
		targetY,
		sourcePosition,
		targetPosition,
		selected,
		data,
		source: _source,
		target: _target,
	} = props;

	const [edgePath] = getSmoothStepPath({
		sourceX,
		sourceY,
		sourcePosition,
		targetX,
		targetY,
		targetPosition,
	});

	const activeContacts = data?.activeContacts || [];
	const edgeAriaLabel = `Connection from node to node${activeContacts.length > 0 ? `, ${activeContacts.length} contacts on this path` : ''}`;

	return (
		<>
			<g role='img' aria-label={edgeAriaLabel}>
				<BaseEdge
					id={id}
					path={edgePath}
					markerEnd={MarkerType.ArrowClosed}
					style={{
						stroke: selected ? brandPrimary : EDGE_DEFAULT_COLOR,
						strokeWidth: selected ? 3 : 2,
					}}
				/>
			</g>
			{activeContacts.length > 0 && (
				<ContactFlowVisualizer
					edgeId={id}
					sourceX={sourceX}
					sourceY={sourceY}
					targetX={targetX}
					targetY={targetY}
					sourcePosition={sourcePosition}
					targetPosition={targetPosition}
					activeContacts={activeContacts}
				/>
			)}
		</>
	);
}
